<template>
    <div class="au-preload-scene">
        <img src="images/icon-only-transparent.png" class="preload-splash-img">
        <div class="dot-flashing"></div>
    </div>
</template>

<script setup lang="ts">
</script>

<style lang="scss">
.au-preload-scene {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.preload-splash-img {
    width: 50%;
    aspect-ratio: 1/1;
    // height: auto;
    margin-bottom: 10vh;
}

.au-logo {
    font-family: Modeka, sans-serif;
    //font-size: min(25vw, 46px);
    font-size: 30px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 15vh;
    line-height: 53px;
    text-shadow: -0.03em 0 0 #00bcd4, 0.03em 0 0 #8400ff;
}
</style>